import { render } from "./BodyClass.vue?vue&type=template&id=628c8ce2"
import script from "./BodyClass.vue?vue&type=script&lang=js"
export * from "./BodyClass.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__